import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import {labels, currentResource} from '../../../util/utils';
import Utility from '../../../util/utilityfunctions';
import ExcelJS from 'exceljs/dist/exceljs';
import {saveAs} from 'file-saver';
import {forEach} from 'lodash';
import {getProjectEngUsers} from '../../../actions/Project/engagementUsersAction';
import Button from '../../CoreWrappers/Button';

const ExportToExcel = (props) => {
	const [isExporting, setIsExporting] = useState(false);
	const projectEngagementsUsers = useSelector((store) => store.projectEngagementsUsers);
	const [isButtonClick, setIsButtonClick] = useState(false);
	const dispatch = useDispatch();
	useEffect(() => {
		if (_.size(projectEngagementsUsers) > 0 && isButtonClick) {
			exportData();
		}
	}, [projectEngagementsUsers]);
	const exportToExcelOptionClick = () => {
		setIsButtonClick(true);
		if (_.size(projectEngagementsUsers) <= 0) {
			getEngagementContactDetails();
		} else {
			exportData();
		}
	};

	const exportData = () => {
		setIsExporting(true);
		props.setIsDisabled && props.setIsDisabled(true);
		const originalData = props.getDataToExport();
		var workbook = new ExcelJS.Workbook();
		var worksheet = workbook.addWorksheet(originalData.worksheetName);
		worksheet.columns = originalData.columns;

		var removeDuplicates = _.filter(originalData.data, (dataItem, index) => {
			return originalData.data.indexOf(dataItem) == index;
		});

		const data = _.orderBy(removeDuplicates, 'engDes');

		forEach(data, (dataItem) => {
			let engId = dataItem.engId;
			let engUsers = _.filter(projectEngagementsUsers, (enguser) => {
				return enguser.canvasEngagementID == engId;
			});
			let uniqueEngUsers = _.uniqBy(engUsers, 'emailAddress');
			const orderedUsersByEmail = _.orderBy(uniqueEngUsers, 'emailAddress');
			const orderedUsersByName = _.orderBy(uniqueEngUsers, ['firstName', 'lastName']);
			dataItem.ContactEmail = orderedUsersByEmail.map((u) => u.emailAddress).join('; ');
			dataItem.ContactName = orderedUsersByName.map((u) => u.firstName + ' ' + u.lastName).join('; ');
			worksheet.addRow(dataItem);
		});
		worksheet.getRow(1).font = {bold: true};

		workbook.xlsx
			.writeBuffer()
			.then((buffer) => {
				saveAs(new Blob([buffer]), originalData.title + '.xlsx');
				setIsExporting(false);
				setIsButtonClick(false);
				props.setIsDisabled && props.setIsDisabled(false);
			})
			.catch((err) => console.log('Error writing excel export', err));
	};

	const getEngagementContactDetails = () => {
		dispatch(getProjectEngUsers(Utility.getProjectIdFromUrl()));
	};

	const label = props.buttonLabel ?? labels.exportData;

	const defaultRender = () => {
		const btnProps = {
			variant: 'text-alt',
			onClick: exportToExcelOptionClick,
			label: label,
			disabled: isExporting,
			title: props.buttonTitle
		};
		if (props.className) btnProps.className = props.className;
		return <Button {...btnProps} />;
	};

	return props?.customRender
		? props.customRender({onClick: exportToExcelOptionClick, label, title: props.buttonTitle, disabled: isExporting})
		: defaultRender();
};

ExportToExcel.propTypes = {
	customRender: PropTypes.func
};

ExportToExcel.defaultProps = {
	customRender: null
};

export default ExportToExcel;
